const SlideOutOfService = ({ personName, onNext }) => {

  return (
    <>
      <div>
        <div className="card-out-of-service">
          <div className="card-content">

            <div className="text-container text-content">
              <h1 className="thank-you-title">{personName}, you're outside of our service area</h1>
              <div className="message">
                <span>
                  We're a rapidly growing company, so we'll put you first on our list and let <br /> you know as soon as we are available in your area.
                </span>
              </div>
            </div>

            <div className="image-container">
              <img src={'/images/out-of-service-area.svg'} alt="G1" className="radius-border image-fit" />
            </div>

            <div className="button-container">
              <a href="https://cabanapools.com/" onClick={(e) => { e.preventDefault(); window.location.href = 'https://cabanapools.com/'; }} className="no-decoration">
                <span className="primary-shadow-btn">RETURN HOME</span>
              </a>
            </div>
            <input type="hidden" id="progress_slide_1" data-width="100%" />
          </div>
        </div>
        <style jsx>{`  
        .image-center {
          width: 30%;
          height: auto;
          object-fit: cover;
          object-position: center;
          margin-top: 50px;
        }
        .card-out-of-service .text-content {
            text-align: center;
        }
        .radius-border {  
          border-radius: 10px 10px 0 0;  
        }  
        .text-content {  
          padding: 15px 20px 25px;  
        }  
        .card-out-of-service {  
          width: 70%;  
          margin: 20px auto;  
          background-color: #fff;  
          border-radius: 10px;  
          overflow: hidden;  
          text-align: center;
        }  
        .card-content {  
          text-align: left;  
        }  
        .card-out-of-service .image-container {  
          text-align: center;  
          width: 60%;  
          overflow: hidden;  
          margin: 0 auto;
        }  
        .image-fit {  
          width: 100%;
          height: auto;  
          object-fit: cover;  
          object-position: center;  
        }  
        .thank-you-title {  
          font-size: 40px;  
          margin-top: 20px;  
          margin-bottom: 20px;
          font-weight: 700;
        }  
        .message {  
          font-size: 20px;
          font-weight: 400;
          line-height: 1.5;  
        }  
        .option-text {  
          color: #007bff;  
          font-size: 16px;  
        }  
        .button-container {  
          text-align: center;  
          margin-top: 30px;  
          padding-bottom: 40px;  
        }  
        .btn {  
          background-color: #007bff;  
          color: #fff;  
          padding: 10px 20px;  
          border: none;  
          border-radius: 5px;  
          cursor: pointer;  
          font-size: 16px;  
          transition: background-color 0.3s;  
        }  
        .btn:hover {  
          background-color: #0056b3;  
        }  
        .no-decoration {  
          text-decoration: none;  
        }  

        @media (max-width: 1024px) {  
           .card-out-of-service .image-container {
              width: 100%;
           }          
        }
  
        @media (max-width: 768px) {  
          .thank-you-title {  
            font-size: 28px;  
          }  
          .message {  
            font-size: 14px;  
          } 
          .option-text {  
            font-size: 14px;  
          }  
          .btn {  
            padding: 8px 16px;  
            font-size: 14px;  
          }  
        }  
  
        @media (max-width: 480px) {  
          .text-content {  
            padding: 10px 15px;  
          }  
          .thank-you-title {  
            font-size: 28px;  
          }  
          .message {  
            font-size: 14px;  
          }  
          .option-text {  
            font-size: 14px;  
          }  
          .btn {  
            padding: 8px 16px;  
            font-size: 14px;  
          }   
        }  
      `}</style>
      </div>
    </>
  );
};

export default SlideOutOfService;
